
























































































































































































import Vue from 'vue';
import { mapState } from 'vuex';

export default Vue.extend({
    props: {
        value: {
            type: Boolean,
        },
        userId: {
            type: Number,
        },
        title: {
            type: String,
        },
    },
    data() {
        return {
            loadingSchedules: false,
            loadingStops: false,
            loadingDates: false,
            loadingAreas: false,
            loading: false,
            valid: true,
            allowedDatesRaw: [] as Array<string>,
            scheduleList: [],
            otherWayScheduleList: [],
            stopsFromList: [],
            stopsToList: [],
            areasList: [],
            formData: {
                twoWay: undefined as undefined | string,
                date: null,
                scheduleId: null,
                pickupStop: null,
                dropoffStop: null,
                scheduleIdBack: null,
                fromArea: null,
                toArea: null,
            },
        };
    },
    computed: {
        ...mapState('texts', ['booking']),
    },
    methods: {
        allowedDates(val: string) {
            return this.allowedDatesRaw.includes(val);
        },
        closeForm() {
            this.$emit('input', false);
            // @ts-ignore
            this.$refs.form.reset();
        },
        async saveForm() {
            // @ts-ignore
            if (this.$refs.form.validate()) {
                try {
                    this.loading = true;
                    await this.$hipApi.addUserTicket(this.userId, this.formData);
                    this.closeForm();
                    this.$notifier.showSuccess(this.booking.succeeded);
                    this.$emit('onSave');
                } catch (err) {
                    this.$notifier.showError(err?.error?.message || err?.message || err);
                }
                this.loading = false;
            }
        },
        async fetchDates() {
            // @ts-ignore
            this.$refs.form.resetValidation();
            this.formData.date = null;
            this.formData.pickupStop = null;
            this.formData.dropoffStop = null;
            this.formData.scheduleId = null;
            this.formData.scheduleIdBack = null;
            if (this.formData.fromArea && this.formData.toArea) {
                try {
                    this.loadingDates = true;
                    const fromAreaObj: any = this.areasList.find((area: any) => area.areaId === this.formData.fromArea);
                    const toAreaObj: any = fromAreaObj.destinations.find((area: any) => area.areaId === this.formData.toArea);
                    if (toAreaObj && !toAreaObj.roundtripAllowed && this.formData.twoWay === 'true') {
                        this.allowedDatesRaw = [];
                    } else {
                        // @ts-ignore
                        this.allowedDatesRaw = (await this.$hipApi.getAvailableDates(this.userId, this.formData.twoWay, this.formData.fromArea, this.formData.toArea)).dates
                            .filter((date: any) => date.status.disabled === false)
                            .map((date: any) => date.date);
                    }
                } catch (err) {
                    this.$notifier.showError(err?.error?.message || err?.message || err);
                }
                this.loadingDates = false;
            }
        },
        async fetchSchedules() {
            // @ts-ignore
            this.$refs.form.resetValidation();
            this.formData.scheduleId = null;
            this.formData.scheduleIdBack = null;
            if (this.formData.pickupStop && this.formData.dropoffStop) {
                try {
                    this.loadingSchedules = true;
                    // @ts-ignore
                    const schedulesLists = await this.$hipApi.getAvailableSchedules(this.userId, this.formData.date, this.formData.pickupStop, this.formData.dropoffStop, this.formData.twoWay);
                    this.scheduleList = schedulesLists.schedules;
                    this.otherWayScheduleList = schedulesLists.otherWaySchedules;
                } catch (err) {
                    this.$notifier.showError(err?.error?.message || err?.message || err);
                }
                this.loadingSchedules = false;
            }
        },
        async fetchStops() {
            // @ts-ignore
            this.$refs.form.resetValidation();
            this.formData.pickupStop = null;
            this.formData.dropoffStop = null;
            this.formData.scheduleId = null;
            this.formData.scheduleIdBack = null;
            try {
                this.loadingStops = true;
                if (this.formData.date) {
                    // @ts-ignore
                    const res = await this.$hipApi.getAvailableStops(this.userId, this.formData.date, this.formData.twoWay, this.formData.fromArea, this.formData.toArea);
                    this.stopsFromList = res.stopsFrom;
                    this.stopsToList = res.stopsTo;
                }
            } catch (err) {
                this.$notifier.showError(err?.error?.message || err?.message || err);
            }
            this.loadingStops = false;
        },
        async fetchAreas() {
            if (this.areasList.length === 0) {
                this.formData.date = null;
                this.formData.pickupStop = null;
                this.formData.dropoffStop = null;
                this.formData.scheduleId = null;
                this.formData.scheduleIdBack = null;
                this.formData.fromArea = null;
                this.formData.toArea = null;
                try {
                    this.loadingAreas = true;
                    // @ts-ignore
                    const res = await this.$hipApi.getAvailableAreas(this.userId);
                    this.areasList = res;
                } catch (err) {
                    this.$notifier.showError(err?.error?.message || err?.message || err);
                }
                this.loadingAreas = false;
            } else {
                this.fetchDates();
            }
        },
    },
});
